module.exports = __webpack_public_path__ + "static/media/logo_footer.fdf1f235.png";